function NXShoppingCart({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4290_2377)">
        <path
          d="M20.013 12.8215H6.57444L4.93158 4.60721H21.3601C21.4804 4.60765 21.5988 4.63443 21.7076 4.68569C21.8162 4.73693 21.9123 4.8114 21.989 4.90383C22.0659 4.99624 22.1214 5.10439 22.1518 5.2206C22.1822 5.33683 22.1868 5.45831 22.1651 5.57649L20.818 12.1479C20.7866 12.3379 20.688 12.5104 20.5403 12.6339C20.3926 12.7575 20.2055 12.8241 20.013 12.8215Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.9316 4.60722L4.2416 1.97865C4.20374 1.79311 4.10291 1.62635 3.95622 1.5066C3.80953 1.38685 3.62598 1.32146 3.4366 1.3215H0.824463"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.57446 12.8215L7.26446 16.2715C7.30233 16.457 7.40315 16.6238 7.54984 16.7435C7.69653 16.8633 7.88011 16.9286 8.06946 16.9286H18.0744"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.253 22.6787C16.7994 22.6787 16.4316 22.3108 16.4316 21.8572C16.4316 21.4036 16.7994 21.0358 17.253 21.0358C17.7068 21.0358 18.0744 21.4036 18.0744 21.8572C18.0744 22.3108 17.7068 22.6787 17.253 22.6787Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.03877 22.6787C8.58512 22.6787 8.21735 22.3108 8.21735 21.8572C8.21735 21.4036 8.58512 21.0358 9.03877 21.0358C9.49243 21.0358 9.8602 21.4036 9.8602 21.8572C9.8602 22.3108 9.49243 22.6787 9.03877 22.6787Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4290_2377">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500061)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXShoppingCart;
